import { useCallback } from "react";
import { List } from "@fluentui/react/lib/List";

import { MissingFields } from "Model/MissingFields";
import { hasNoElements } from "Utils/Array";
import { IMissingFieldsListProps } from "./IMissingFieldsListProps";
import { MissingFieldsEntry } from "./MissingFieldsEntry";

export function MissingFieldsList(props: IMissingFieldsListProps): JSX.Element {
  const { missingFields } = props;
  const onRenderCell = useCallback((item: MissingFields, index: number, isScrolling: boolean): JSX.Element => {
    if (isScrolling) {
      return <div />;
    }

    return <MissingFieldsEntry index={index} entry={item} />;
  }, []);
  return (
    <List
      items={flattenMissingFields(missingFields)}
      onRenderCell={onRenderCell}
    />
  );
}

function flattenMissingFields(missingFields: MissingFields[]): MissingFields[] {
  function reducer(output: MissingFields[], child: MissingFields) {
    output.push(child);
    if (hasNoElements(child.children)) {
      return output;
    }

    return child.children.reduce(reducer, output);
  }

  return missingFields.reduce(reducer, []);
}
